import { createFileRoute } from '@tanstack/react-router';

import StoreListsPage from '@/components/store/lists/Page';

export const Route = createFileRoute('/store/lists')({
	component: StoreListsPage,
});
